class ApiService {
  private static instance: ApiService;
  private readonly baseUrl = import.meta.env.DEV
    ? "/api"
    : import.meta.env.VITE_API_URL;

  static getInstance(): ApiService {
    if (!ApiService.instance) {
      ApiService.instance = new ApiService();
    }
    return ApiService.instance;
  }

  private constructUrl(endpoint: string, params?: Record<string, any>): string {
    const path = `${this.baseUrl}${endpoint}`;

    if (!params || Object.keys(params).length === 0) {
      return path;
    }

    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        searchParams.append(key, value.toString());
      }
    });

    const queryString = searchParams.toString();
    return queryString ? `${path}?${queryString}` : path;
  }

  async get<T>(endpoint: string, params?: Record<string, any>): Promise<T> {
    const url = this.constructUrl(endpoint, params);

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`API request failed: ${response.statusText}`);
    }
    return response.json();
  }
}

export const api = ApiService.getInstance();
